import { FC } from "react";

import { BulkGridSelectionControl } from "@ryde/layout";

/** Live map toolbar: bulk grid selection for visible rows. */

export const LiveMapSelectAllCheckbox: FC = () => {
  return (
    <BulkGridSelectionControl
      className="live-map-select-all"
      enableSelectRows
    />
  );
};
